import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { PublicNav } from "../components/PublicNav";

export default function Terms() {
  const { t } = useTranslation();
  const sections = t("terms.sections", { returnObjects: true });
  return (
    <div className="min-h-screen" style={{ background: "#111111" }}>
      <PublicNav testIdPrefix="terms" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-20">
        <div className="mb-12">
          <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: "#7c3aed" }}>{t("legal.eyebrow")}</p>
          <h1 className="text-4xl sm:text-5xl font-black text-white mb-4" style={{ fontFamily: "Epilogue, sans-serif" }}>
            {t("terms.title")}
          </h1>
          <p className="text-sm" style={{ color: "#6b6b6b" }}>{t("legal.lastUpdated")}</p>
        </div>

        <div className="space-y-6">
          {sections.map((s) => (
            <div key={s.title} className="rounded-2xl p-6" style={{ background: "#161616", border: "1px solid #252525" }}>
              <h2 className="text-sm font-bold text-white mb-3">{s.title}</h2>
              <p className="text-sm leading-relaxed" style={{ color: "#6b6b6b" }}>{s.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link to="/contact" data-testid="terms-contact-link" className="text-sm transition-colors" style={{ color: "#c084fc" }}>
            {t("terms.contactCta")}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
